import type { ReactNode } from "react";

export function Steps({ children }: { children: ReactNode }) {
  return (
    <ol className="my-6 space-y-4 border-l-2 border-forest-200 pl-6 [counter-reset:steps]">
      {children}
    </ol>
  );
}

export function Step({ title, children }: { title: string; children?: ReactNode }) {
  return (
    <li className="relative [counter-increment:steps] before:absolute before:-left-[2.1rem] before:flex before:h-7 before:w-7 before:items-center before:justify-center before:rounded-full before:bg-forest-600 before:font-display before:text-sm before:font-semibold before:text-cream-50 before:content-[counter(steps)]">
      <p className="font-display text-lg font-semibold text-bark-900">{title}</p>
      {children && <div className="mt-1 text-bark-700">{children}</div>}
    </li>
  );
}
